import axios from "axios";
import { API_URL } from "../utils/setApiUrl";

// Get free slots for a device in batch
const getFreeSlotsBatch = async (deviceId, count) => {
  try {
    const response = await axios.post(`${API_URL}/freeSlotsBatch`, {
      device: deviceId,
      count: count,
    });
    return response.data;
  } catch (error) {
    console.error("Error getting free slots batch:", error);
    throw error;
  }
};

// Send batch insert commands
const batchInsert = async (insertCommands) => {
  try {
    // Add a timeout to the request to prevent hanging
    const response = await axios.post(
      `${API_URL}/batchInsert`,
      insertCommands,
      {
        timeout: 60000, // 60 second timeout
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error performing batch insert:", error);
    throw error;
  }
};

// Send batch remove commands
const batchRemove = async (removeCommands) => {
  try {
    // Add a timeout to the request to prevent hanging
    const response = await axios.post(
      `${API_URL}/batchRemove`,
      removeCommands,
      {
        timeout: 60000, // 60 second timeout
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error performing batch remove:", error);
    throw error;
  }
};

// Single free slot (for backward compatibility)
const getFreeSlot = async (deviceId) => {
  try {
    const response = await axios.post(`${API_URL}/freeSlot`, {
      device: deviceId,
    });
    return response.data.message;
  } catch (error) {
    console.error("Error getting free slot:", error);
    throw error;
  }
};

// Single insert (for backward compatibility)
const insert = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/insert`, data, {
      timeout: 10000, // 10 second timeout
    });
    return response.data;
  } catch (error) {
    console.error("Error performing insert:", error);
    throw error;
  }
};

// Single remove (for backward compatibility)
const remove = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/remove`, data, {
      timeout: 10000, // 10 second timeout
    });
    return response.data;
  } catch (error) {
    console.error("Error performing remove:", error);
    throw error;
  }
};

// Remove a user from all devices
const removeUserEverywhere = async (userId) => {
  try {
    const response = await axios.post(
      `${API_URL}/removeUserEverywhere`,
      {
        user: userId,
      },
      {
        timeout: 10000, // 10 second timeout
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error removing user from all devices:", error);
    throw error;
  }
};

const MqttService = {
  getFreeSlotsBatch,
  batchInsert,
  batchRemove,
  getFreeSlot,
  insert,
  remove,
  removeUserEverywhere,
};

export default MqttService;
